<app-page-heading [key]="'lite-login.title'"
                  [regions]="[]"
                  [carriers]="carriers"
                  [selectedCarrier]="carrier"
                  (selectedCarrierChange)="updateCarrier($event)"
                  [clearable]="false"
                  [helper]="true"
                  [helperContent]="helper">
</app-page-heading>

<section class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-12">
                    <button type="button" class="btn btn-primary btn-outline btn-lg pull-left" (click)="returnToList()">
                        <span class="fa fa-arrow-left"></span>
                    </button>&nbsp;
                </div>
            </div>

            <br>

            <div class="ibox float-e-margins">
                <div class="ibox-content border-primary">
                    <form #accessForm="ngForm" novalidate>
                        <div class="form-group">
                            <label class="control-label" for="email-address">
                                <span [i18n]="'lite-login.creation.labels.email.title'"></span>&nbsp;<span>*</span>
                            </label>
                            <input class="form-control input-lg" type="email" name="email-address" id="email-address"
                                   [email]="true" [(ngModel)]="access.emailAddress" #emailInput="ngModel" [readonly]="mode === 'readonly'" required>
                            <label class="error" *ngIf="emailInput.dirty && access.emailAddress === ''"
                                   [i18n]="'lite-login.creation.labels.required'">
                            </label>
                            <label class="error" *ngIf="emailInput.dirty && access.emailAddress !== '' && emailInput.invalid"
                                   [i18n]="'lite-login.creation.labels.email.invalid'">
                            </label>
                            <small class="help-block m-b-none" [i18n]="'lite-login.creation.labels.email.helper'"></small>
                        </div>
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label" for="driver-country">
                                        <span [i18n]="'lite-login.creation.labels.country.title'"></span>&nbsp;<span>*</span>
                                    </label>
                                    <select class="form-control input-lg" [(ngModel)]="access.driverCountry.id"
                                            name="driver-country" id="driver-country" [disabled]="mode === 'readonly'" required>
                                        <option *ngFor="let country of countries"
                                                [ngValue]="country.id">{{country.name}}</option>
                                    </select>
                                    <small class="help-block m-b-none" [i18n]="'lite-login.creation.labels.country.helper'"></small>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label" for="driver-language"><span
                                        [i18n]="'lite-login.creation.labels.language.title'"></span>&nbsp;<span>*</span></label>
                                    <select class="form-control input-lg" [(ngModel)]="access.driverLocale"
                                            name="driver-language" id="driver-language" [disabled]="mode === 'readonly'" required>
                                        <option *ngFor="let lang of languages" [ngValue]="lang.cmblLangCode">
                                            <span [i18n]="'languages.' + lang.labelKey"></span>
                                        </option>
                                    </select>
                                    <small class="help-block m-b-none" [i18n]="'lite-login.creation.labels.language.helper'"></small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label class="control-label" for="load-id">
                                        <span [i18n]="'lite-login.creation.labels.load-id.title'"></span>&nbsp;<span>*</span>
                                    </label>
                                    <input class="form-control input-lg" type="text" name="load-id" id="load-id" [readonly]="mode === 'readonly'" required
                                           [(ngModel)]="loadId" (ngModelChange)="warning = false; loadInfoError = false">
                                    <small class="help-block m-b-none" [i18n]="'lite-login.creation.labels.load-id.helper'"></small>
                                </div>
                            </div>
                            <div class="col-xs-6" *ngIf="mode !== 'readonly'">
                                <div class="form-group _zone">
                                    <label class="control-label force-text-normal" for="delivery-number" [i18n]="'lite-login.creation.labels.delivery-number.title'"></label>
                                    <div class="row">
                                        <div class="col-sm-8 no-padding-right">
                                            <input class="form-control input-lg" name="delivery-number" id="delivery-number"
                                                   type="text" [(ngModel)]="deliveryNumber">
                                            <span class="text-danger" *ngIf="loadInfoError && loadErrorSource === 'delivery'"
                                                   [i18n]="'lite-login.errors.delivery-info-search'">
                                            </span>
                                        </div>
                                        <div class="col-sm-4 no-padding">
                                            <button class="btn btn-primary btn-lg no-margins" [class.btn-outline]="deliveryNumber"
                                                    type="button" (click)="searchLoadInfoByDeliveryNumber()" [disabled]="!deliveryNumber">
                                                <span [i18n]="'lite-login.actions.search'"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6" *ngIf="mode === 'readonly'">
                                <div class="form-group">
                                    <label class="control-label" for="vehicle" [i18n]="'lite-login.creation.labels.vehicle.title'"></label>
                                    <input class="form-control input-lg" name="vehicle" id="vehicle"
                                           type="text" [(ngModel)]="access.vehicleId" [readonly]="true">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <fieldset class="col-xs-12">
                                <div class="form-group">
                                    <app-data-filter-fieldSet [largeTitle]="true" [fieldsetTitleKey]="'lite-login.creation.labels.optional-info.title'">
                                        <small class="help-block m-b-none" [i18n]="'lite-login.creation.labels.optional-helper'"></small>

                                        <div class="row">
                                            <div class="col-xs-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="driver-name" [i18n]="'lite-login.creation.labels.driver-name.title'"></label>
                                                    <input class="form-control input-lg" type="text" name="driver-name" id="driver-name"
                                                           [(ngModel)]="access.driverName" [readonly]="mode === 'readonly'">
                                                </div>
                                            </div>
                                            <div class="col-xs-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="cabin-license-plate" [i18n]="'lite-login.creation.labels.cabin-license-plate.title'"></label>
                                                    <input class="form-control input-lg" type="text" name="cabin-license-plate" id="cabin-license-plate"
                                                           [(ngModel)]="access.cabinLicensePlate" [readonly]="mode === 'readonly'">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-xs-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="driver-id" [i18n]="'lite-login.creation.labels.driver-id.title'"></label>
                                                    <input class="form-control input-lg" type="text" name="driver-id" id="driver-id"
                                                           [(ngModel)]="access.driverId" [readonly]="mode === 'readonly'">
                                                </div>
                                            </div>
                                            <div class="col-xs-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="trailer-id" [i18n]="'lite-login.creation.labels.trailer-id.title'"></label>
                                                    <input class="form-control input-lg" type="text" name="trailer-id" id="trailer-id"
                                                           [(ngModel)]="access.trailerId" [readonly]="mode === 'readonly'">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-xs-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="phone-number" [i18n]="'lite-login.creation.labels.driver-phone-number.title'"></label>
                                                    <input class="form-control input-lg" type="tel" name="phone-number" id="phone-number"
                                                           [(ngModel)]="access.driverPhoneNumber" [readonly]="mode === 'readonly'">
                                                    <small class="help-block m-b-none" [i18n]="'lite-login.creation.labels.driver-phone-number.helper'"></small>
                                                </div>
                                            </div>
                                            <div class="col-xs-6"></div>
                                        </div>
                                    </app-data-filter-fieldSet>
                                </div>

                                <div class="alert alert-info space-top-10">
                                    <i class="fa fa-info-circle"></i>
                                    <span [i18n]="'lite-login.helpers.lifetime'"></span>
                                </div>

                                <div class="alert alert-danger space-top-10" *ngIf="loadInfoError && loadErrorSource === 'load'">
                                    <i class="fa fa-times"></i>
                                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.errors.load-info-search', params: { carrierName: carrier.name }}]"></span>
                                </div>

                                <div class="form-buttons pull-right" *ngIf="mode !== 'readonly'">
                                    <button type="button" class="btn btn-default btn-lg" (click)="returnToList()"
                                            [i18n]="updating ? 'lite-login.actions.cancel' : 'lite-login.actions.cancel-creation'">
                                    </button>
                                    <button type="button" class="btn btn-primary btn-lg"
                                            (click)="activate = false; completeForm()"
                                            [disabled]="accessForm.invalid || accessForm.pristine || loadInfoError || loading">
                                        <i class="fa fa-check"></i>&nbsp;<span [i18n]="updating ? 'lite-login.actions.update-without-activating' : 'lite-login.actions.create-without-activating'"></span>
                                    </button>
                                    <button type="button" class="btn btn-primary btn-lg"
                                            (click)="activate = true; completeForm()"
                                            [disabled]="accessForm.invalid || loadInfoError || loading">
                                        <i class="fa fa-check"></i>&nbsp;<span [i18n]="updating ? 'lite-login.actions.update-and-activate' : 'lite-login.actions.create-and-activate'"></span>
                                    </button>
                                </div>
                            </fieldset>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #helper>
    <h3 class="text-primary text-left" [i18n]="'lite-login.helpers.section'"></h3>
    <spacer [size]="8"></spacer>
    <div class="stepContainer">
        <span class="step">1</span>
        <span class="stepContainer-label" [i18n]="'lite-login.helpers.step-1'"></span>
    </div>
    <div class="stepContainer">
        <span class="step">2</span>
        <span class="stepContainer-label" [i18n]="'lite-login.helpers.step-2'"></span>
    </div>
    <div class="stepContainer">
        <span class="step">3</span>
        <span class="stepContainer-label" [i18n]="'lite-login.helpers.step-3'"></span>
    </div>
</ng-template>

<ng-template #reassignPopup let-loadInfo="loadInfo">
    <div class="alert no-margins">
        <i class="fa fa-exclamation-triangle"></i>
        <div>
            <div>
                <span [i18n]="'lite-login.errors.load-info-reassign.content1'"></span>&nbsp;
                <strong class="text-primary">#{{loadInfo.loadId}}</strong>&nbsp;
                <span [i18n]="'lite-login.errors.load-info-reassign.content2'"></span>&nbsp;
                <strong class="text-primary">{{loadInfo.assignedVehicle}}</strong>
            </div>
            <div>
                <span [i18n]="'lite-login.errors.load-info-reassign.consequence'"></span>&nbsp;
                <strong class="text-primary">{{loadInfo.assignedVehicle}}</strong>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #errorPopup let-error="error">
    <div style="white-space: break-spaces">{{error}}</div>
</ng-template>
